import { StartupStatus } from "../types/StartupStatus";

export function mapStartupStatusToText(status: StartupStatus): string {
  switch (status) {
    case StartupStatus.Bootstrapping:
      return "Bootstrapping";
    case StartupStatus.Building:
      return "Building";
    case StartupStatus.Raising:
      return "Raising Funds";
    case StartupStatus.Exiting:
      return "Exiting";
    case StartupStatus.ShuttingDown:
      return "Shutting Down";
    case StartupStatus.ExitAcquired:
      return "Exit: Acquired";
    case StartupStatus.ExitDissolved:
      return "Exit: Dissolved";
    case StartupStatus.Zombie:
      return "Zombie";
    case StartupStatus.Unknown:
      return "Unknown";
    default:
      return status;
  }
}
